'use strict';

// import IntersectionObserver from 'intersection-observer-polyfill';

const aos = {
    init: function (){
        aos.img();
        aos.txt();
    },
    img: function() {
        // Configuration de l'observer (optionnel)
        const config = {
            threshold: 0.15
        };

        // Instanciation de l'intersectionObserver pour le lazy loading
        let observer = new IntersectionObserver(function (entries, self) {
            // Pour chaque entrée ciblée (les images ici)
            entries.forEach(entry => {
                // L'API Javascript vérifie que l'entrée existe...
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    // L'image est chargée, l'API peut s'arrêter jusqu'à la prochaine, etc.
                    self.unobserve(entry.target);
                }
            });
        }, config);

        // Sélectionne les images et lance l'observer asynchrone
        const images = document.querySelectorAll('[data-img-in-view]');
        images.forEach(img => {
            // Observation des images à charger au fur et à mesure
            observer.observe(img);
        });
    },
    txt: function() {
        const config = {
            threshold: 0.15
        };

        let observer = new IntersectionObserver(function (entries, self) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    self.unobserve(entry.target);
                }
            });
        }, config);

        const texts = document.querySelectorAll('[data-text-in-view]');
        texts.forEach(txt => {
            observer.observe(txt);
        });
    }
}

export default aos;


// WEBPACK FOOTER //
// ./src/scripts/anims/appear-on-scroll.js